import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { PdfItemModel } from "src/core/categories/categories.models";
import { CategoriesSandbox } from "src/core/categories/categories.sandbox";
import { MessageService } from "src/core/services/messages.service";

@Component({
    templateUrl: './pdfs.dialog.html',
    styleUrls: ['./pdfs.dialog.scss']
})
export class PdfsDialogComponent implements OnInit, OnDestroy {
    private subs: Subscription[] = [];

    value = '';
    file: File;
    fileURL: string;
    fileName: string;

    pdfs: PdfItemModel[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) data: any,
        private categoriesSandbox: CategoriesSandbox,
        private message: MessageService,
        private cd: ChangeDetectorRef,
        private dialogRef: MatDialogRef<PdfsDialogComponent>,
        private dialog: MatDialog
    ) {
        this.categoriesSandbox.doClearCreatePdfItemState();
        this.categoriesSandbox.doClearGetPdfItemState();
        this.categoriesSandbox.doClearGetPdfListState();
        this.categoriesSandbox.doClearRemovePdfItemState();
        this.categoriesSandbox.doClearUpdatePdfItemState();
    }

    ngOnInit(): void {
        // this.getPdfsList();

        this.subs.push(this.categoriesSandbox.getPdfListData$.subscribe(res => {
            if (res) {
                console.log(res);
                this.pdfs = res || [];
            }
        }))
        this.subs.push(this.categoriesSandbox.getPdfListFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))

        this.subs.push(this.categoriesSandbox.createPdfItemData$.subscribe(res => {
            if (res) {
                console.log(res);
                this.value = '';
                this.file = null;
                this.fileName = '';
                this.fileURL = null;
                // this.getPdfsList();

                this.dialogRef.close(res);
            }
        }))
        this.subs.push(this.categoriesSandbox.createPdfItemFailData$.subscribe(res => {
            if (res) {
                this.message.log('Server error!');
            }
        }))
    }

    private getPdfsList(): void {
        this.categoriesSandbox.doGetPdfList({})
    }

    addPdf(): void {
        if (!this.file || !this.value) {
            this.message.log('File and description - required!')
            return;
        }

        const params: FormData = new FormData();
        params.append('description', this.value);
        params.append('value', this.file, this.file.name);

        this.categoriesSandbox.doCreatePdfItem(params)
    }

    selectPdf(item: PdfItemModel): void {
        this.dialogRef.close(item);
    }

    onFileChanged(event: any): void {
        const f: File = event.target.files[0] as File;

        if (f && f.size < 31457280) {
            this.file = f;
            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onload = (e) => {
                this.fileURL = reader.result.toString();
            };
        } else {
            // this.message.log('File size must be lowerest than 30 mb');
        }
    }

    ngOnDestroy(): void {
        this.subs.map(s => s.unsubscribe());
    }
}